import { render, staticRenderFns } from "./documento-detalle.vue?vue&type=template&id=02063361"
import script from "./documento-detalle.vue?vue&type=script&lang=js"
export * from "./documento-detalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports